import { render, staticRenderFns } from "./ListLiveTutorialsAction.vue?vue&type=template&id=15867f4e"
import script from "./ListLiveTutorialsAction.vue?vue&type=script&lang=js"
export * from "./ListLiveTutorialsAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports